import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement>;

const base = {
  width: 20,
  height: 20,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.8,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
  "aria-hidden": true,
};

export function BrandLogo(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      {...props}
    >
      <path d="M5 7h2.2c2 0 1.8 3 4.1 3H13" stroke="currentColor" strokeWidth="2.2" />
      <path d="M5 17h2.2c2 0 1.8-3 4.1-3H13" stroke="currentColor" strokeWidth="2.2" />
      <path d="M15.5 10h1.1c1.7 0 1.5-3 3.1-3H21" stroke="currentColor" strokeWidth="2.2" />
      <path d="M15.5 14h1.1c1.7 0 1.5 3 3.1 3H21" stroke="currentColor" strokeWidth="2.2" />
      <rect x="2" y="4" width="3" height="6" rx="1" fill="currentColor" />
      <rect x="2" y="14" width="3" height="6" rx="1" fill="currentColor" />
      <rect x="12.5" y="7" width="3" height="10" rx="1" fill="currentColor" />
      <rect x="20" y="4" width="2" height="6" rx="1" fill="currentColor" />
      <rect x="20" y="14" width="2" height="6" rx="1" fill="currentColor" />
    </svg>
  );
}

export function UploadIcon(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M12 16V4" />
      <path d="m7.5 8.5 4.5-4.5 4.5 4.5" />
      <path d="M5 13.5a4 4 0 0 0 .5 8h13a3.5 3.5 0 0 0 .45-6.97A6.7 6.7 0 0 0 6.1 12.4" />
    </svg>
  );
}

export function DownloadIcon(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M12 3v12" />
      <path d="m7.5 10.5 4.5 4.5 4.5-4.5" />
      <path d="M4 19.5h16" />
    </svg>
  );
}

export function DataIcon(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <rect x="4" y="3" width="16" height="18" rx="2" />
      <path d="M8 8h8M8 12h8M8 16h5" />
    </svg>
  );
}

export function HelpIcon(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <circle cx="12" cy="12" r="9" />
      <path d="M9.7 9a2.5 2.5 0 1 1 3.85 2.1c-.95.65-1.55 1.1-1.55 2.4" />
      <path d="M12 17.4h.01" />
    </svg>
  );
}

export function CheckIcon(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="m6.5 12.5 3.4 3.4 7.6-8" />
    </svg>
  );
}

export function CloseIcon(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="m6 6 12 12M18 6 6 18" />
    </svg>
  );
}
